import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HttpServiceWorkerBypassInteceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.reportProgress) {
      /**
       * Service Workers / fetch don't support progress events so bypass it
       * https://github.com/w3c/ServiceWorker/issues/1141
       */
      const newRequest = req.clone({
        setHeaders: {
          'ngsw-bypass': 'true',
        },
      });

      return next.handle(newRequest);
    } else {
      return next.handle(req);
    }
  }
}
